import { render, staticRenderFns } from "./PlayerCarrierSpecialistHired.vue?vue&type=template&id=1842df02&scoped=true&"
import script from "./PlayerCarrierSpecialistHired.vue?vue&type=script&lang=js&"
export * from "./PlayerCarrierSpecialistHired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842df02",
  null
  
)

export default component.exports